import { Language } from '^/types';

export default {
  upload: {
    [Language.EN_US]: 'Upload',
    [Language.KO_KR]: '업로드',
  },
  delete: {
    [Language.EN_US]: 'Delete',
    [Language.KO_KR]: '삭제',
  },
  fileTypes: {
    [Language.EN_US]: 'JPG, PNG',
    [Language.KO_KR]: 'JPG, PNG',
  },
  imageSizeError: {
    [Language.EN_US]: 'Image size must be less than 2MB',
    [Language.KO_KR]: '이미지 크기는 2MB 이하여야 합니다',
  },
  imageRecommendation: {
    [Language.EN_US]: 'Recommended: 200×200px, Max: 2MB',
    [Language.KO_KR]: '권장: 200×200px, 최대: 2MB',
  },
  imageNotSupported: {
    [Language.EN_US]: 'Image format not supported. Please use JPG or PNG format.',
    [Language.KO_KR]: '지원되지 않는 이미지 형식입니다. JPG 또는 PNG 형식을 사용해주세요.',
  },
};
